// extracted by mini-css-extract-plugin
export default {"root":"_36kDe","variant-horizontal":"_1PPez","variantHorizontal":"_1PPez","title":"_3Ii3z","message":"_1j0le","core-star":"_1RzpX","coreStar":"_1RzpX"};